module.exports = __webpack_public_path__ + "static/media/CaRi-HEART Overview_Insurers_Oct 2021_rev7 UK.7f996da6.pdf";